import { useAtomValue } from 'jotai';
import { ProductsForSeriesAtom, SingleSeriesAtom } from '../../../store/SeriesStore';
import { MyBooksAtom } from '../../../store/MyBooksStore';
import { LoginAtom, LoginStatus } from '../../../store/AccountStore';
import React, { useEffect, useState } from 'react';
import { Product } from '../../../Models/Product';
import { Comic } from '../../../Models/Comic';
import { findFreeChapters, findFreeVolumes, findPurchasedChapter, findPurchasedVolume } from '../../../utils/utils';
import ReadChapterInSeries from '../../ReadChapterInSeries/ReadChapterInSeries';
import Free from './ReadFree/Free';

export function RenderChapterToRead() {
    const series = useAtomValue(SingleSeriesAtom);
    const products = useAtomValue(ProductsForSeriesAtom);
    const myBook = useAtomValue(MyBooksAtom);
    const loginStatus = useAtomValue(LoginAtom);

    const [chapterToRead, setChapterToRead] = useState<{ type: 'Volume' | 'Chapter' | null; data: Product | Comic }>({
        type: null,
        data: null,
    });

    useEffect(() => {
        if (!products && !myBook) {
            return;
        }
        const freeChapters = findFreeChapters(products, loginStatus === "LoggedIn");
        const freeVolumes = findFreeVolumes(products, loginStatus === "LoggedIn");
        const volumeToRead = findPurchasedVolume(products, myBook);
        // chapterFromVolumes was correct when the chapters are readable
        // through a purchased volume, but for now this feature is not allowed
        // let chapterFromVolumes = null;

        console.log('freeChapters', freeChapters);
        console.log('volumeToRead', volumeToRead);

        if (freeChapters) {
            setChapterToRead({
                type: 'Chapter',
                data: freeChapters,
            });
            return;
        }

        if (freeVolumes) {
            setChapterToRead({
                type: 'Volume',
                data: freeVolumes,
            });
            return;
        }

        if (volumeToRead) {
            // chapterFromVolumes = volumeToRead;
            // chapterFromVolumes = volumeToRead?.chapters?.find(c => c.variants[0].priceType === 'Paid');
            setChapterToRead({
                type: 'Volume',
                data: volumeToRead,
            });
            return;
        }

        // From here needed further tests after chapters are open
        const chapterFromChapters = findPurchasedChapter(products, myBook);

        if (chapterFromChapters) {
            setChapterToRead({
                type: 'Chapter',
                data: chapterFromChapters,
            });
            return;
        }

        // if (chapterFromChapters) {
        //     setChapterToRead({
        //         type: 'Chapter',
        //         data: chapterFromVolumes ? chapterFromVolumes : chapterFromChapters,
        //     });
        //     return;
        // }
    }, [products, myBook, loginStatus]);

    if (chapterToRead.type !== null) {
        return (<ReadChapterInSeries preloadImage={false} chapterToRead={chapterToRead} />);
    }

    const freeChapter = series?.getFirstFreeChapter();

    if (freeChapter) {
        return (
            <Free arrowText={'Read Now'} link={'reader/' + freeChapter.id?.toString()} />
        );
    }

    return null;
}